import React, { useState, useEffect } from 'react';
import {
    Accordion, AccordionSummary, Grid, Table, Checkbox, TextField,
    AccordionDetails, FormControlLabel, Button
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { useSelector, useDispatch } from 'react-redux';
import { setCargaDatos } from "../../Redux/V2/ContratoRedux";
import Cookies from 'universal-cookie';
import { json } from 'react-router-dom';

const TareasSac = ({ from }) => {
    const dispatch = useDispatch()
    //const servicios = useSelector((store) => store.contratoV2.contrato)
    //const causas = useSelector((store) => store.contratoV2.Causas)
    const tareasValidacion = useSelector((store) => store.contratoV2.TareasValidacion)
    const entrevista = useSelector((store) => store.contratoV2.Entrevista)
    const actualizacion = useSelector((store) => store.contratoV2.Actualizacion)
    const contratoCancelado = useSelector((store) => store.contratoV2.ContratoCancelado);
    const contratoFiniquitado = useSelector((store) => store.contratoV2.ContratoFiniquitado);
    const contratoFirmado = useSelector((store) => store.contratoV2.ContratoFirmado);
    const contratoValidado = useSelector((store) => store.contratoV2.ContratoValidado);

    //contratoValidado?.validado

    const cookies = new Cookies();


    const [selectedTasks, setSelectedTasks] = useState([]); // Inicialmente vacío
    const [disabledComponent, setDisabledComponent] = useState(false);

    const bloqueadoTotalmente =
        (contratoValidado?.validado && actualizacion?.actualizacion?.status != 1) ||
        !!contratoCancelado?.cancelado ||
        !!contratoFiniquitado?.finiquitado

    /** TAREAS  en public task.js*/
    const [SAC_TASK, setSAC_TASK] = useState([])
    const [User_SAC, setUser_SAC] = useState([])
    useEffect(() => {
        getTareasSac();
        setUser_SAC(window.USER_SAC)
    }, [])

    const getTareasSac = async () => {
        var list = await dispatch(setCargaDatos("Tareas", "get", 2));
        setSAC_TASK(list);
    }

    useEffect(() => {
        //-> enviar a Legal
        if (entrevista.contractId) {
            dispatch(setCargaDatos("TareasValidacion", "get", entrevista.contractId))
        }
    }, [entrevista])

    useEffect(() => {
        if (actualizacion?.actualizacion?.status == 1 && actualizacion?.actualizacion?.type == 1) {
            setDisabledComponent(true)
        }
        else if (actualizacion?.actualizacion?.status == 1) { //actualizacion en curso, cargar el defendido de la actualizacion
            if (actualizacion.actualizacionModelos && actualizacion.actualizacionModelos.length > 0) {
                const _objAct = actualizacion.actualizacionModelos.find(obj => obj.model == "tareasSac");
                if (_objAct != null) {
                    const _tasks = JSON.parse(JSON.parse(_objAct.json).tasks)
                    setSelectedTasks(_tasks);
                    return
                }
            }
        }
        console.log(tareasValidacion)
        if (tareasValidacion?.sac)
            setSelectedTasks(tareasValidacion.sac)
    }, [tareasValidacion])

    const handleCheckboxChange = (event, task) => {
        const { checked } = event.target;

        setSelectedTasks(prevTasks => {
            if (checked) {
                // Si se marca, agregar la tarea al array
                return [...prevTasks, { name: task.name, description: task.description, extra: "", userId: 0 }];
            } else {
                // Si se desmarca, eliminar del array
                return prevTasks.filter(t => t.name !== task.name);
            }
        });
    };

    const handleExtraChange = (event, taskName) => {
        const { value } = event.target;
        setSelectedTasks(prevTasks =>
            prevTasks.map(task =>
                task.name === taskName ? { ...task, extra: value } : task
            )
        );
    };

    const handleUserChange = (event, taskName) => {
        const { value } = event.target;
        setSelectedTasks(prevTasks =>
            prevTasks.map(task =>
                task.name === taskName ? { ...task, userId: Number(value) } : task
            )
        );
    };

    const saveTask = async () => {
        var payload = {
            type: "sac",
            contractId: entrevista.contractId,
            tasks: JSON.stringify(selectedTasks)
        }


        if (actualizacion?.actualizacion?.status == 1) { //si es actualizacion en curso
            var aux = {
                json: JSON.stringify(payload),
                model: "tareasSac",
                actualizacionId: actualizacion.actualizacion.id,
            }
            var exito = await dispatch(setCargaDatos("Actualizacion", "put", aux));
            return
        }

        console.log(payload)
        await dispatch(setCargaDatos("TareasValidacion", "post", payload))
    }


    const tienePermisosValidacion = (() => {
        const firmado =
            contratoFirmado?.firmado === true ||
            contratoFirmado?.firmado === 'true';

        if (!firmado) return false;

        let rolId = NaN;
        try {
            const raw = cookies.get('rolId');
            if (raw != null) rolId = parseInt(raw, 10);
        } catch { /* noop */ }

        const lista = Array.isArray(window?.ROLID_VALIDA) ? window.ROLID_VALIDA : [];
        return !Number.isNaN(rolId) && lista.includes(rolId);
    })();


    return (
        <>
            {/* GESTION DE TAREAS SAC */}
            <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panelSac-content" id="panelSac-header" >
                    TAREAS DE SAC
                </AccordionSummary>
                <AccordionDetails>
                    {
                        //JSON.stringify(selectedTasks)
                    }
                    <Table>
                        {SAC_TASK?.map((task) => {
                            const isChecked = selectedTasks.some(selected => selected.name === task.name);
                            const selectedUser = selectedTasks.find(selected => selected.name === task.name)?.userId || 0;
                            const selectedExtra = selectedTasks.find(selected => selected.name === task.name)?.extra || "";

                            return (
                                <tr key={task.name}>
                                    <td>
                                        <FormControlLabel
                                            disabled={!tienePermisosValidacion || bloqueadoTotalmente || disabledComponent}
                                            control={<Checkbox
                                                checked={isChecked}
                                                onChange={(e) => handleCheckboxChange(e, task)}
                                            />}
                                            label={`${task.name}`}
                                        />
                                    </td>
                                    <td>{`${task.description.slice(0, 60)}...`}</td>
                                    <td style={{ paddingRight: "10px" }}>
                                        <TextField
                                            label="Comentario"
                                            value={selectedExtra}
                                            onChange={(e) => handleExtraChange(e, task.name)}
                                            variant="outlined"
                                            fullWidth
                                            size='small'
                                            disabled={!tienePermisosValidacion || bloqueadoTotalmente || !isChecked || disabledComponent}
                                        />
                                    </td>
                                    <td>
                                        <select
                                            disabled={!tienePermisosValidacion || bloqueadoTotalmente || !isChecked || disabledComponent}
                                            value={selectedUser}
                                            onChange={(e) => handleUserChange(e, task.name)}>
                                            {User_SAC?.map((user) => (
                                                <option key={user.userId} value={user.userId}> {user.Name} </option>
                                            ))}
                                        </select>
                                    </td>
                                </tr>
                            );
                        })}
                    </Table>
                    <Grid item xs={12} >
                        <Button variant="contained" onClick={saveTask} disabled={!tienePermisosValidacion || bloqueadoTotalmente || disabledComponent}>Guardar SAC</Button>
                    </Grid>
                </AccordionDetails>
            </Accordion>
        </>
    );
};

export default TareasSac;